var isObject = require('./$.is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.an-object.js
// module id = 171
// module chunks = 2